//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      activeFilterId: 0
    };
  },
  props: ['filters', 'total'],
  methods: {
    updateFilter: function updateFilter(id) {
      this.activeFilterId = id;
      this.$emit('filter', this.activeFilterId);
    }
  }
};